import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
// No changes needed, useAuth is already a named export

/**
 * PrivateRoute component to protect routes that require authentication
 * Redirects to login page if user is not authenticated
 */
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the current location to redirect back after login
    return (
      <Navigate 
        to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} 
        replace 
      />
    );
  }

  // Render children if authenticated
  return children;
};

export default PrivateRoute;
